const initGrowthStudio = (section) => {
    if (!section || section.dataset.growthStudioInitialized === 'true') return;
    section.dataset.growthStudioInitialized = 'true';

    const stages = section.querySelectorAll('[data-growth-stage]');
    const banners = section.querySelectorAll('[data-promo-banner]');
    const slides = section.querySelectorAll('[data-promo-slide]');
    const visual = section.querySelector('[data-promo-visual]');

    let activeBannerIndex = 0;
    let bannerTimer;
    let bannerPreloadTimer;
    let bannerPreloadIdleCallback;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const cancelBannerPreload = () => {
      window.clearTimeout(bannerPreloadTimer);
      if (bannerPreloadIdleCallback && 'cancelIdleCallback' in window) {
        window.cancelIdleCallback(bannerPreloadIdleCallback);
      }
      bannerPreloadIdleCallback = undefined;
    };

    const preloadSlide = (slideIndex) => {
      const slide = slides[slideIndex];
      const image = slide?.querySelector('img');
      if (!image || image.dataset.promoPreloaded === 'true') return;

      image.dataset.promoPreloaded = 'true';
      const preloader = new Image();
      preloader.decoding = 'async';
      preloader.fetchPriority = 'low';
      if (image.srcset) preloader.srcset = image.srcset;
      if (image.sizes) preloader.sizes = image.sizes;
      preloader.src = image.currentSrc || image.src;
      preloader.decode?.().catch(() => {});
      slide.promoPreloadImage = preloader;
    };

    const scheduleNextBannerPreload = () => {
      cancelBannerPreload();
      if (reduceMotion || slides.length < 2 || document.hidden) return;

      const nextIndex = (activeBannerIndex + 1) % slides.length;
      const preloadNext = () => preloadSlide(nextIndex);

      if ('requestIdleCallback' in window) {
        bannerPreloadIdleCallback = window.requestIdleCallback(preloadNext, { timeout: 1800 });
      } else {
        bannerPreloadTimer = window.setTimeout(preloadNext, 900);
      }
    };

    const selectStage = (stage) => {
      stages.forEach((item) => {
        const active = item === stage;
        item.classList.toggle('is-active', active);
      });
    };

    const selectBanner = (banner, bannerIndex = Number(banner.dataset.promoBannerIndex || 0)) => {
      activeBannerIndex = bannerIndex;
      banners.forEach((item) => {
        const active = item === banner;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      slides.forEach((item, itemIndex) => {
        const active = itemIndex === bannerIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', String(!active));
        if (item.matches('a')) item.tabIndex = active ? 0 : -1;
      });
      scheduleNextBannerPreload();
    };

    const stopBannerRotation = () => window.clearInterval(bannerTimer);
    const startBannerRotation = () => {
      stopBannerRotation();
      if (reduceMotion || banners.length < 2 || document.hidden) return;
      bannerTimer = window.setInterval(() => {
        const nextIndex = (activeBannerIndex + 1) % banners.length;
        selectBanner(banners[nextIndex], nextIndex);
      }, 5200);
    };

    banners.forEach((banner, bannerIndex) => {
      const activateBanner = () => {
        selectBanner(banner, bannerIndex);
        startBannerRotation();
      };

      banner.addEventListener('click', activateBanner);
      banner.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        activateBanner();
      });
    });

    section.addEventListener('shopify:block:select', (event) => {
      const selectedBanner = event.target.closest?.('[data-promo-banner]');
      if (selectedBanner) {
        selectBanner(selectedBanner);
        stopBannerRotation();
        return;
      }

      const selectedStage = event.target.closest?.('[data-growth-stage]');
      if (selectedStage) selectStage(selectedStage);
    });

    visual?.addEventListener('pointerenter', stopBannerRotation);
    visual?.addEventListener('pointerleave', startBannerRotation);
    visual?.addEventListener('focusin', stopBannerRotation);
    visual?.addEventListener('focusout', startBannerRotation);
    document.addEventListener('visibilitychange', startBannerRotation);
    section.growthStudioCleanup = () => {
      stopBannerRotation();
      cancelBannerPreload();
      document.removeEventListener('visibilitychange', startBannerRotation);
    };
    startBannerRotation();
    scheduleNextBannerPreload();
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-growth-studio]').forEach(initGrowthStudio);
});

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.matches?.('[data-growth-studio]')
    ? event.target
    : event.target.querySelector?.('[data-growth-studio]');

  initGrowthStudio(section);
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target.matches?.('[data-growth-studio]')
    ? event.target
    : event.target.querySelector?.('[data-growth-studio]');

  section?.growthStudioCleanup?.();
});
